import { Skeleton } from "@/components/ui/skeleton";

/**
 * ChatPageSkeleton - Full-page skeleton for /chat routes
 * 
 * INV-SKELETON: Used by RouteAwareAppFallback for chat routes.
 * Matches TaxOracleChatArea layout structure.
 */
export function ChatPageSkeleton() {
  return (
    <div className="flex flex-col h-full min-h-screen bg-background">
      {/* Chat area with centered content */}
      <div className="flex-1 px-4">
        <div className="max-w-3xl mx-auto pt-16 pb-16">
          {/* Empty state skeleton - suggestion buttons */}
          <div className="text-center space-y-6">
            <Skeleton className="h-8 w-48 mx-auto" />
            <Skeleton className="h-5 w-72 mx-auto" />
            <div className="space-y-3 max-w-md mx-auto mt-8">
              <Skeleton className="h-12 w-full rounded-lg" />
              <Skeleton className="h-12 w-full rounded-lg" />
              <Skeleton className="h-12 w-full rounded-lg" />
            </div>
          </div>
        </div>
      </div>
      
      {/* Input area at bottom */}
      <div className="border-t border-border bg-background p-4">
        <div className="max-w-3xl mx-auto flex gap-2">
          <Skeleton className="flex-1 h-16 rounded-md" />
          <Skeleton className="h-10 w-10 rounded-md shrink-0" />
        </div>
      </div>
    </div>
  );
}
